import { Coord } from "../../../../../../../../../src/types/Interface";
import getCoord from "../../../../../../../../../src/utils/coord/getCoord";
import getAngleBetweenPoints from "../../../../../../../../../src/utils/math/getAngleBtwPoints";


export default function getExtendedEndCoord(centerofLine: Coord, pivotCoord: Coord, rotation: number) {
  const radian = getAngleBetweenPoints(centerofLine, pivotCoord);
  return rotation == -Math.PI || rotation == Math.PI ? pivotCoord : getCoord(pivotCoord, 60, radian);
}


